import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  CircularProgress,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../services/api";
import CenterFocusStrongIcon from "@material-ui/icons/CenterFocusStrong";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import SaveIcon from "@material-ui/icons/Save";
import PrintIcon from "@material-ui/icons/Print";
import SettingsIcon from "@material-ui/icons/Settings";
import CreateConnectionModal from "../components/CreateConnectionModal";

// 📱 Formata número de telefone em padrão brasileiro
const formatarTelefone = (numero = "") => {
  const limpo = numero.replace(/[@:].*$/, "").trim();
  if (!/^\d+$/.test(limpo)) return numero;

  if (limpo.length === 13) {
    return limpo.replace(
      /^(\d{2})(\d{2})(\d{5})(\d{4})$/,
      "+$1 ($2) $3-$4"
    );
  } else if (limpo.length === 12) {
    return limpo.replace(
      /^(\d{2})(\d{2})(\d{4})(\d{4})$/,
      "+$1 ($2) $3-$4"
    );
  } else {
    return limpo;
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 64px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#edf1f5",
    padding: theme.spacing(3),
  },
  paper: {
    width: 420,
    padding: theme.spacing(4),
    borderRadius: 18,
    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
  qrBox: {
    width: 260,
    height: 260,
    margin: "20px auto",
    borderRadius: 14,
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  qrImage: { width: "100%", height: "100%", objectFit: "contain" },
  buttonContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  iniciar: {
    backgroundColor: "#16a34a",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#15803d" },
  },
  qr: {
    backgroundColor: "#2563eb",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#1d4ed8" },
  },
  encerrar: {
    backgroundColor: "#dc2626",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#b91c1c" },
  },
  apagar: {
    backgroundColor: "#6b21a8",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#581c87" },
  },
  novo: {
    backgroundColor: "#16a34a",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#11863cff" },
  },
  config: {
    backgroundColor: "#f59e0b",
    color: "#fff",
    fontWeight: 600,
    "&:hover": { backgroundColor: "#d97706" },
  },
  status: {
    backgroundColor: "#e5e7eb",
    display: "inline-block",
    borderRadius: 20,
    padding: "4px 14px",
    fontSize: 13,
    color: "#374151",
    fontWeight: 500,
    marginBottom: theme.spacing(1.5),
  },
  conectadoBox: {
    backgroundColor: "#dcfce7",
    border: "2px solid #22c55e",
    borderRadius: 16,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  conectadoIcon: { color: "#16a34a", fontSize: 80, marginBottom: theme.spacing(1) },
  conectadoTexto: { fontWeight: 600, fontSize: 18, color: "#166534" },
  dialogTitle: {
    backgroundColor: "#f59e0b",
    color: "#fff",
    fontWeight: 600,
  },
}));

export default function ConectarWhatsApp() {
  const classes = useStyles();
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("Verificando status...");
  const [connected, setConnected] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [openConfig, setOpenConfig] = useState(false); // 🆕 Modal de configuração

  // 🖨️ Configuração de impressão
  const [cabecalho, setCabecalho] = useState(
    localStorage.getItem("printCabecalho") || ""
  );
  const [rodape, setRodape] = useState(
    localStorage.getItem("printRodape") || ""
  );

  const statusRef = useRef(null);
  const refreshRef = useRef(null);

  // Estado para conexão recuperada do backend
    const [token, setToken] = useState(localStorage.getItem("whatsToken") || "");
    const [name, setName] = useState(localStorage.getItem("whatsName") || "");

  // Sempre monta os headers atuais
  const headers = name ? { "x-whats-name": name } : {};

  // Ao montar, busca a conexão do backend e preenche estado/localStorage
  useEffect(() => {
    async function fetchConexao() {
      try {
        const { data } = await api.get("/whatsapp/list");
        if (data?.success && Array.isArray(data.data) && data.data.length > 0) {
          const conexao = data.data[0]; // pega a mais recente
          if (conexao.name) {
            setName(conexao.name);
            localStorage.setItem("whatsName", conexao.name);
          }
          if (conexao.token) {
            setToken(conexao.token);
            localStorage.setItem("whatsToken", conexao.token);
          }
          if (conexao.typebot) {
            localStorage.setItem("whatsTypebot", conexao.typebot);
          }
          if (conexao.printCabecalho) {
            localStorage.setItem("printCabecalho", conexao.printCabecalho);
          }
          if (conexao.printRodape) {
            localStorage.setItem("printRodape", conexao.printRodape);
          }
        }
      } catch (err) {
        setStatus("Nenhuma conexão encontrada no banco.");
      }
    }
    if (!localStorage.getItem("whatsName") || !localStorage.getItem("whatsToken")) {
      fetchConexao();
    }
  }, []);

  /** 🔄 Verifica status da sessão */
  const verificarStatus = async () => {
    if (!name) return;

    try {
      const { data } = await api.get("/whatsapp/status", { headers });
      const s = data?.data || {};
      const isConnected = s.connected === true;
      const isLoggedIn = s.loggedIn === true;

      setConnected(isConnected);
      setLoggedIn(isLoggedIn);

      if (s?.jid || s?.JID || s?.me?.id) {
        localStorage.setItem("whatsNumber", s.jid || s.JID || s.me.id);
      }

      if (isLoggedIn) {
        setStatus("✅ Conectado ao WhatsApp");
        setQrCode(null);
        clearInterval(refreshRef.current);
      } else if (isConnected && !isLoggedIn) {
        setStatus("📱 Aguardando leitura do QR...");
      } else {
        setStatus("🔌 Sessão não iniciada.");
      }
    } catch (err) {
      setStatus("❌ Erro ao obter status");
      console.error("Erro ao verificar status:", err);
    }
  };

  /** 🔁 Inicia monitoramento automático */
  const iniciarMonitoramento = () => {
    clearInterval(statusRef.current);
    statusRef.current = setInterval(verificarStatus, 5000);
  };

  /** ▶️ Iniciar sessão */
  const iniciarSessao = async () => {
    if (!name) {
      toast.warning("Crie uma conexão antes de iniciar.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/whatsapp/connect", {}, { headers });
      if (data.success) {
        toast.success("Sessão criada. Agora clique em 'Mostrar QR'.");
        setStatus("Sessão criada. Clique em 'Mostrar QR' para conectar.");
        iniciarMonitoramento();
      }
    } catch (error) {
      toast.error("Erro ao iniciar sessão.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /** 📸 Buscar QR */
  const buscarQR = async () => {
    if (!name) {
      toast.warning("Crie uma conexão antes de mostrar o QR.");
      return;
    }

    try {
      const { data } = await api.get("/whatsapp/qr", { headers });
      const raw = data?.data?.qrCode || null;

      if (data.success && raw) {
        const qr = raw.startsWith("data:image")
          ? raw
          : `data:image/png;base64,${raw}`;
        setQrCode(qr);
        setStatus("📱 Escaneie o QR no seu WhatsApp");
      } else if (data?.data?.connected && data?.data?.loggedIn) {
        setConnected(true);
        setLoggedIn(true);
        setStatus("✅ Conectado ao WhatsApp");
      } else {
        setStatus("⚠️ Nenhum QR disponível no momento.");
      }
    } catch (error) {
      setStatus("❌ Erro ao obter QR");
      console.error("Erro ao buscar QR:", error);
    }
  };

  /** 🔁 Mostrar QR + auto-refresh */
  const mostrarQR = async () => {
    setLoading(true);
    await buscarQR();
    setLoading(false);
    clearInterval(refreshRef.current);
    refreshRef.current = setInterval(buscarQR, 15000);
  };

  /** 🚪 Encerrar sessão */
  const encerrarSessao = async () => {
    if (!name) return;
    setLoading(true);
    try {
      const { data } = await api.post("/whatsapp/logout", {}, { headers });
      if (data.success) {
        toast.success("Sessão encerrada.");
        setQrCode(null);
        setConnected(false);
        setLoggedIn(false);
        setStatus("Sessão encerrada");
        clearInterval(statusRef.current);
        clearInterval(refreshRef.current);
      }
    } catch (error) {
      toast.error("Erro ao encerrar sessão");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /** 🗑️ Apagar conexão (API + banco) */
  const apagarConexao = async () => {
    if (!name) {
      toast.warning("Nenhuma conexão selecionada.");
      return;
    }

    if (!window.confirm("Tem certeza que deseja apagar esta conexão?")) return;

    setLoading(true);
    try {
      const { data } = await api.delete("/whatsapp/delete", { headers });
      if (data.success) {
        toast.success("Conexão apagada com sucesso!");
        localStorage.removeItem("whatsName");
        localStorage.removeItem("whatsToken");
        setQrCode(null);
        setConnected(false);
        setLoggedIn(false);
        setStatus("Conexão removida");
      }
    } catch (error) {
      toast.error("Erro ao apagar conexão.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /** 💾 Salvar configurações de impressão */
  const salvarConfigImpressao = async () => {
    try {
      await api.post("/whatsapp/print-config", {
        printCabecalho: cabecalho,
        printRodape: rodape,
      });

      // mantém no localStorage como fallback
      localStorage.setItem("printCabecalho", cabecalho);
      localStorage.setItem("printRodape", rodape);

      toast.success("Configuração salva no banco!");
      setOpenConfig(false);
    } catch (err) {
      toast.error("Erro ao salvar configuração no banco");
    }
  };

  /** 🧭 Inicialização */
  useEffect(() => {
    if (name) {
      verificarStatus();
      iniciarMonitoramento();
    } else {
      setStatus("Nenhuma conexão criada.");
    }

    return () => {
      clearInterval(statusRef.current);
      clearInterval(refreshRef.current);
    };
  }, [name]);

  /** ⏳ Carregar configurações de impressão do servidor */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/whatsapp/print-config");
        const cab = data?.printCabecalho ?? "";
        const rod = data?.printRodape ?? "";
        setCabecalho(cab);
        setRodape(rod);
        localStorage.setItem("printCabecalho", cab);
        localStorage.setItem("printRodape", rod);
      } catch (err) {
        // sem erro fatal: mantém valores do localStorage já existentes
      }
    })();
  }, []);

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h6" gutterBottom>
          📲 Conectar WhatsApp
        </Typography>

        <Box display="flex" gap={1} justifyContent="center" style={{ marginBottom: 16 }}>
          <Button
            className={classes.novo}
            variant="contained"
            startIcon={<AddCircleIcon />}
            onClick={() => setOpenCreate(true)}
          >
            Nova Conexão
          </Button>
          &nbsp;
          <Button
            className={classes.config}
            variant="contained"
            startIcon={<SettingsIcon />}
            onClick={() => setOpenConfig(true)}
          >
            Config. Impressão
          </Button>
        </Box>

        {loggedIn ? (
          <Box className={classes.conectadoBox}>
            <CheckCircleIcon className={classes.conectadoIcon} />
            <Typography className={classes.conectadoTexto}>
              Conectado com sucesso!
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              Seu WhatsApp está ativo e sincronizado.
            </Typography>

            {localStorage.getItem("whatsNumber") && (
              <Typography
                variant="body2"
                style={{
                  marginTop: 8,
                  backgroundColor: "#f3f4f6",
                  padding: "8px 12px",
                  borderRadius: 8,
                  fontFamily: "monospace",
                  color: "#374151",
                  wordBreak: "break-all",
                }}
              >
                📞 <b>Número conectado:</b>{" "}
                {formatarTelefone(localStorage.getItem("whatsNumber"))}
              </Typography>
            )}

            {localStorage.getItem("whatsName") && (
              <Typography
                variant="body2"
                style={{
                  marginTop: 12,
                  backgroundColor: "#f3f4f6",
                  padding: "8px 12px",
                  borderRadius: 8,
                  fontFamily: "monospace",
                  color: "#374151",
                  wordBreak: "break-all",
                }}
              >
                🧠 <b>ID do Fluxo:</b>{" "}
                {localStorage.getItem("whatsTypebot") || "Não definido"}
              </Typography>
            )}

            <Box mt={3} display="flex" gap={1}>
              <Button
                className={classes.encerrar}
                variant="contained"
                startIcon={<ExitToAppIcon />}
                onClick={encerrarSessao}
                disabled={loading}
              >
                DESCONECTAR
              </Button>
              &nbsp;
              <Button
                className={classes.apagar}
                variant="contained"
                startIcon={<DeleteForeverIcon />}
                onClick={apagarConexao}
                disabled={loading}
              >
                APAGAR
              </Button>
            </Box>
          </Box>
        ) : (
          <>
            <Typography className={classes.status}>{status}</Typography>

            <Box className={classes.qrBox}>
              {loading ? (
                <CircularProgress />
              ) : qrCode ? (
                <img src={qrCode} alt="QR" className={classes.qrImage} />
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Nenhum QR gerado ainda.
                </Typography>
              )}
            </Box>

            <Typography variant="body2" color="textSecondary">
              Abra o WhatsApp → Menu → Aparelhos conectados → Conectar
            </Typography>

            <Box className={classes.buttonContainer}>
              <Button
                className={classes.iniciar}
                variant="contained"
                startIcon={<PowerSettingsNewIcon />}
                onClick={iniciarSessao}
                disabled={loading || connected}
              >
                INICIAR
              </Button>

              <Button
                className={classes.qr}
                variant="contained"
                startIcon={<CenterFocusStrongIcon />}
                onClick={mostrarQR}
                disabled={loading || !connected}
              >
                MOSTRAR QR
              </Button>

              <Button
                className={classes.encerrar}
                variant="contained"
                startIcon={<ExitToAppIcon />}
                onClick={encerrarSessao}
                disabled={loading}
              >
                ENCERRAR
              </Button>

              <Button
                className={classes.apagar}
                variant="contained"
                startIcon={<DeleteForeverIcon />}
                onClick={apagarConexao}
                disabled={loading}
              >
                APAGAR
              </Button>
            </Box>
          </>
        )}

        {/* 🖨️ Modal de Configuração de Impressão */}
        <Dialog open={openConfig} onClose={() => setOpenConfig(false)} maxWidth="sm" fullWidth>
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center" gap={1}>
              <PrintIcon /> Configuração de Impressão
            </Box>
          </DialogTitle>
          <DialogContent style={{ paddingTop: 20 }}>
            <TextField
              label="Cabeçalho da Impressão"
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              placeholder="Ex: RESTAURANTE DELIVERY&#10;Rua Exemplo, 123&#10;Tel: (11) 99999-9999"
              value={cabecalho}
              onChange={(e) => setCabecalho(e.target.value)}
              style={{ marginBottom: 16 }}
              helperText="Texto que aparecerá no topo de cada impressão"
            />

            <TextField
              label="Rodapé da Impressão"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              placeholder="Ex: Obrigado pela preferencia!&#10;Volte sempre!"
              value={rodape}
              onChange={(e) => setRodape(e.target.value)}
              helperText="Texto que aparecerá no final de cada impressão"
            />
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <Button onClick={() => setOpenConfig(false)}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={salvarConfigImpressao}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        <CreateConnectionModal open={openCreate} onClose={() => setOpenCreate(false)} />
      </Paper>
    </Box>
  );
}
